import {
  UserOutlined,
  ProfileOutlined,
  SendOutlined,
  LineChartOutlined,
  DollarOutlined,
  SettingOutlined,
  CreditCardOutlined,
  AppstoreOutlined,
  NotificationOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import { useEffect, useState } from "react";
import { useGlobalContext } from "../../providers/GlobalProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { ADMINS_EMAILS } from "../../config";
function SideMenu() {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));
  const {setIsLoggedIn, isPayroll} = useGlobalContext();
  const [selectedKeys, setSelectedKeys] = useState("/");
  const navigate = useNavigate();

  useEffect(() => {
    const pathName = location.pathname;
    setSelectedKeys(pathName);
  }, [location.pathname]);

  const handleMenuClick = (item) => {
    if (item.key === "/logout") {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      setIsLoggedIn(false);
      navigate('/login');
    } else {
      navigate(item.key);
    }
  };

  return (
    <Layout.Sider className="SideMenu" theme="light" breakpoint="lg" collapsedWidth="50" width={238}>
      <Menu
        className="SideMenuVertical"
        mode="inline"
        onClick={handleMenuClick}
        selectedKeys={[selectedKeys]}
        items={[
          {
            label: user?.username,
            icon: <ProfileOutlined />,
            key: "/",
            children: [
              {
                label: "Profile",
                key: "/profile",
              },
              !ADMINS_EMAILS.includes(user.email) && (
              !(user?.parentId) && {
                label: "User Management",
                key: "/subusers",
              }),
              !ADMINS_EMAILS.includes(user.email) && (
              !(user?.parentId) && {
                label: "OA SubAccounts",
                key: "/oasubaccounts",
              }),
              {
                label: "Logout",
                key: "/logout",
              },
            ],
          },
          !ADMINS_EMAILS.includes(user.email) && 
          {
            label: "Contacts",
            key: "/contacts",
            icon: <UserOutlined />,
            children: [
              {
                label: "All",
                key: "/contacts/all",
              },
              {
                label: "GMF",
                key: "/contacts/gmf",
              },
              {
                label: "Segments",
                key: "/contacts/segments",
              },
            ],
          },
          !ADMINS_EMAILS.includes(user.email) && 
          {
            key: "/broadcast",
            icon: <SendOutlined />,
            label: "Broadcast",
            children: [
              {
                label: "Template",
                type: "group",
                key: "/template",
                children: [
                  {
                    label: "Consultant",
                    key: "/template/consultants",
                  },
                  {
                    label: "Transaction",
                    key: "/template/transactions",
                  },
                  {
                    label: "Promotion",
                    key: "/template/promotions",
                  },
                ],
              },
              {
                label: "Send",
                type: "group",
                key: "/send",
                children: [
                  {
                    label: "Consultant Message",
                    key: "/send/consultants",
                  },
                  {
                    label: "Consultant GMF Messages",
                    key: "/send/gmfconsultants",
                  },
                  {
                    label: "Transaction Message",
                    key: "/send/transactions",
                  },
                  {
                    label: "Promotion Message",
                    key: "/send/promotions",
                  },
                ],
              },
            ],
          },
          !ADMINS_EMAILS.includes(user.email) &&  
          {
            label: "ZNS",
            icon: <NotificationOutlined />,
            children: [
              {
                label: "ZNS Template",
                key: "/znstemplate",
              },
              {
                label: "ZNS Campaign",
                key: "/znscamapaign",
              },
              {
                label: "Message Log",
                key: "/messagelogzns",
              },
            ],
          },
          !ADMINS_EMAILS.includes(user.email) &&  
          {
            label: "Analytics",
            icon: <LineChartOutlined />,
            children: [
              {
                label: "Dashboard",
                key: "/dashboard",
              },
              {
                label: "Message Log",
                key: "/messagelog",
              },
            ],
          },
          !ADMINS_EMAILS.includes(user.email) &&  
          {
            label: "Billing",
            icon: <DollarOutlined />,
            key: "/billing",
          },
          !ADMINS_EMAILS.includes(user.email) &&  
          {
            label: "Setting",
            icon: <SettingOutlined />,
            children: [
              {
                label: "OA Accounts",
                key: "/oaaccounts",
              },
              !(user?.parentId) && {
                label: "Connections",
                key: "/connections",
              },
              // {
              //   label: "Preference",
              //   disabled:true,
              //   key: "/preference",
              // },
            ],
          },
          !ADMINS_EMAILS.includes(user.email) &&  isPayroll &&
          {
            label: "Payroll",
            icon: <CreditCardOutlined />,
            key: "payrollpackage",
            children: [
              {
                label: "Payroll",
                key: "/payroll",
              },
              {
                label: "Message Log",
                key: "messagelogpayroll",
              },
            ]
          },
          ADMINS_EMAILS.includes(user.email) && {
            label: "Admins",
            icon: <AppstoreOutlined />,
            children: [
              {
                label: "Packages",
                key: "/packages",
              },
              {
                label: "Packages OA",
                key: "/packagesoa",
              },
              {
                label: "All Users",
                key: "/allusers",
              },
              {
                label: "All Users Deleted",
                key: "/allusersdeleted",
              },
            ]
          }
        ]}
      ></Menu>
    </Layout.Sider>
  );
}
export default SideMenu;
